<template>
  <a-modal
    title="合同预览"
    :width="1180"
    :visible="visible"
    :maskClosable="true"
    :closable="true"
    :confirmLoading="loading"
    :footer="null"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <div>
        <a-form>
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                合同信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                {{ this.data['business_no'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                {{ this.data['contract_number'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                {{ this.data['contract_name'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="运输公司名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['shipping_company'] }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                支付信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="支付方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.$Dictionaries.trade_payment_method[this.data['payment_method']] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="计费方式" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['billing_method'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="支付周期" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['payment_cycle'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="滞期费规定" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['demurrage_terms'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="速遣费规定" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['despatch_terms'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="免堆期" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['free_demurrage_days'] }}（天）
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                财务信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="税率" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['tax_rate'] }}%
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                附件
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="合同附件" :label-col="buttonCol.labelCol" :wrapper-col="buttonCol.wrapperCol">
                <a-table
                  bordered
                  :data-source="attachmentList"
                  :columns="attachmentColumns"
                  v-if="this.attachmentList.length > 0"
                  :pagination="false"
                  key="key">
                  <span slot="file" slot-scope="text">
                    <a-tag :color="text === 1? 'blue' : 'orange'">
                      {{ $Dictionaries.trade_file_type[text] }}
                    </a-tag>
                  </span>
                  <span slot="action" slot-scope="text, record">
                    <template>
                      <a :href="record.url" target="_blank">预览</a>
                    </template>
                  </span>
                </a-table>
                <span v-else>无</span>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { booking_contract_list } from '@/api/trade_contract'
import { booking_contract_attachment_list } from '@/api/trade_contract_attachment'
export default {
  name: 'TableEdit',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        labelCol: {
          xs: { span: 3 },
          sm: { span: 3 }
        },
        wrapperCol: {
          xs: { span: 21 },
          sm: { span: 21 }
        }
      },
      loading: false,
      data: {},
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 200
        },
        {
          title: '类型',
          dataIndex: 'file_type',
          width: 100,
          scopedSlots: { customRender: 'file' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      attachmentList: []
    }
  },
  mounted () {
    this.loadContract()
    this.loadContractAttachment()
  },
  methods: {
    loadContract () {
      this.loading = true
      booking_contract_list({ id: this.model['id'] }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadContractAttachment () {
      booking_contract_attachment_list({ contract_id: this.model['id'] }).then(res => {
        if (res.code === 1000 && res.data.entries) {
          this.attachmentList = res.data.entries
        }
      })
    }
  }
}
</script>
